import {
  IGetPromoDeductionMatchSummaryParams,
  IPromoDeductionMatchSummary,
  IPromotionRepository,
} from "@/core/repositories/promotion";

export class GetPromoDeductionMatchSummaryUseCase {
  constructor(private readonly repo: IPromotionRepository) {}

  async execute(
    params: IGetPromoDeductionMatchSummaryParams,
    refetch = false
  ): Promise<IPromoDeductionMatchSummary[]> {
    return this.repo.getPromoDeductionMatchSummary(params, refetch);
  }
}
